var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "value": _vm.value,
      "disabled": _vm.disabled,
      "clearable": ""
    },
    on: {
      "clear": _vm.clearHandle
    }
  }, [_c('template', {
    slot: "prefix"
  }, [(_vm.value !== '' && _vm.value != null) ? _c('span', {
    staticClass: "icon-picker-selected"
  }, [_c('i', {
    class: _vm.value
  })]) : _vm._e()]), _vm._v(" "), _c('el-option', {
    staticClass: "icon-picker-option",
    attrs: {
      "value": _vm.value
    }
  }, [_c('div', [_c('ul', [_vm._l((_vm.icons.elementIcons), function(icon) {
    return _c('li', {
      key: icon,
      on: {
        "click": function($event) {
          return _vm.iconClick('el-icon-' + icon)
        }
      }
    }, [_c('span', [_c('i', {
      class: 'el-icon-' + icon
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])])], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e367330","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icon-picker/index.vue
// module id = null
// module chunks = 